var _excluded = ["children"];

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { node } from 'prop-types';
import Provider from '../Provider';
import GlobalStyle from './GlobalStyle';
/** This component provides a theme to all React components underneath itself via the context API. */

var ThemeProvider = function ThemeProvider(_ref) {
  var children = _ref.children,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Provider, rest, /*#__PURE__*/React.createElement(GlobalStyle, null), children);
};

ThemeProvider.propTypes = {
  children: node.isRequired
};
export default ThemeProvider;